import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getIdToken } from '../../auth';
import { DeleteRequestDocument } from '../../types/DeleteRequestDocument';
import {  IDocumentById, IHistory} from '../../types/Documentsid';
import { BASE_URL_ENDPOINT } from '../../config/env';

interface IState {
    result: DeleteRequestDocument | any,
    error: any | null;
  }
  
  const initialState: IState = {
    result: '',
    error: null,
  };
  
  // console.log('este es el token en el documentsSlice:', token);
  export const fetchDocumentDeleteRequest = createAsyncThunk(
    'fetchDocumentDeleteRequest',
    async ({repositoryName, id}: {repositoryName: string, id: string }): Promise<any> => {
      try {
        const token = getIdToken();
        const response = await fetch(
          `${BASE_URL_ENDPOINT}/management-ctx/api/v2/deletion-request/${id}`,
          {
            method: 'GET',
            headers: {
              'Content-type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'repository-name':`${repositoryName}`,
              'Authorization': ` Bearer ${token}`,
            },
          },
        );
      
        console.log('fetchDocumentDeleteRequest-Response**:', response);
        return await response.json();
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  );

    const DeleteRequestDocumentsSlice= createSlice({
    name: "DeleteRequestDocumentsSlice",
    initialState,
    reducers:{
    },
    extraReducers(builder) {
        builder.addCase(
          fetchDocumentDeleteRequest.fulfilled, 
          (state, action) => {
            state.result = action.payload;
            console.log("state-fetchDocumentDeleteRequest:",state.result);
            state.error = null;
          }
        );
        builder.addCase(
            fetchDocumentDeleteRequest.rejected, (state, action) => {
                state.error = action.payload;
                console.log("state-error:", state.error
                )
            }
        );
    },
});

export default DeleteRequestDocumentsSlice.reducer;